import { render, staticRenderFns } from "./designType.vue?vue&type=template&id=cb55ae26&scoped=true"
import script from "./designType.vue?vue&type=script&lang=js"
export * from "./designType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb55ae26",
  null
  
)

export default component.exports